import { component } from '@smoovy/component';
import { Observable, observe, unobserve } from '@smoovy/observer';

import { Preloader } from './preloader';
import svcs from '../services';

@component({
  selector: '[data-image-src]'
})
export class ImageSrc {
  private source: string;
  private type: string;
  private load: string;
  private loaded = false;
  private observable?: Observable<HTMLElement>;
  private observing = false;

  constructor(
    protected element: HTMLElement
  ) {
    this.type = this.element.dataset.imageType!;
    this.load = this.element.dataset.imageLoad!;

    const [ url, urlSmall ] = (this.element.dataset.imageSrc || '').split(';');

    this.source = url;

    if (urlSmall && window.innerWidth <= 768) {
      this.source = urlSmall;
    }

    if (this.source && this.load == 'instant') {
      Preloader.add(this.source).then(() => this.parse());
    } else if (this.source && this.load !== 'manual') {
      this.observing = true;
      this.observable = observe(this.element, {
        observeVisibility: true
      });

      this.observable.onVisibilityChanged((visible) => {
        if (visible) {
          this.loadItem();

          if (this.observable) {
            this.observing = false;

            unobserve(this.observable);
          }
        }
      });
    }
  }

  public loadItem(force = false) {
    if ( ! this.loaded || force) {
      if (this.load === 'manual') {
        const [ url, urlSmall ] = (this.element.dataset.imageSrc || '').split(';');

        this.source = url;

        if (urlSmall && window.innerWidth <= 768) {
          this.source = urlSmall;
        }
      }

      Preloader.loadItem(Preloader.create(this.source)).then(() => this.parse());
    }
  }

  private async parse() {
    await svcs.intro.service;

    this.loaded = true;

    setTimeout(() => this.element.classList.add('src-loaded'));

    switch (this.type) {
      case 'bg':
        this.element.style.backgroundImage = `url(${this.source})`;

      default:
        this.element.setAttribute('src', this.source);
    }
  }

  public onDestroy() {
    if (this.observable && this.observing) {
      unobserve(this.observable);
    }
  }
}